"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6970],{

/***/ 284359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronDown_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(999534);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(502888);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);






var SvgChevronDown = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            d: "m11.5 15.713 7.35-7.35q.375-.374.887-.363.513.013.888.388t.375.887-.375.888l-7.7 7.675q-.3.3-.675.45t-.75.15-.75-.15-.675-.45l-7.7-7.7Q2 9.763 2.013 9.263q.012-.5.387-.875t.888-.375.887.375z"
        })
    }));
};
var ChevronDown_default = SvgChevronDown;



/***/ }),

/***/ 201677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronLeft_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(999534);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(502888);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);






var SvgChevronLeft = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            d: "m8.725 11.729 7.35 7.35q.374.375.363.887a1.26 1.26 0 0 1-.388.888q-.375.375-.888.375-.512 0-.887-.375l-7.675-7.7q-.3-.3-.45-.675t-.15-.75.15-.75.45-.675l7.7-7.7q.375-.374.875-.363.5.013.875.388t.375.887-.375.888z"
        })
    }));
};
var ChevronLeft_default = SvgChevronLeft;



/***/ }),

/***/ 887251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronRight_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(999534);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(502888);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);






var SvgChevronRight = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            d: "m15.413 11.7-7.35-7.35a1.17 1.17 0 0 1-.363-.887 1.26 1.26 0 0 1 .388-.888q.375-.375.887-.375.513 0 .888.375l7.675 7.7q.3.3.45.675t.15.75-.15.75-.45.675l-7.7 7.7q-.375.374-.875.363a1.25 1.25 0 0 1-.875-.388 1.21 1.21 0 0 1-.375-.887q0-.513.375-.888z"
        })
    }));
};
var ChevronRight_default = SvgChevronRight;



/***/ }),

/***/ 187096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronUp_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(999534);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(502888);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);






var SvgChevronUp = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            d: "m11.879 8.725-7.35 7.35q-.375.374-.888.363a1.26 1.26 0 0 1-.887-.388 1.21 1.21 0 0 1-.375-.888q0-.512.375-.887l7.7-7.675q.3-.3.675-.45t.75-.15.75.15.675.45l7.7 7.7q.375.375.362.875a1.25 1.25 0 0 1-.387.875q-.375.375-.888.375-.512 0-.887-.375z"
        })
    }));
};
var ChevronUp_default = SvgChevronUp;



/***/ }),

/***/ 235033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FavoritedFilled_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(999534);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(502888);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);






var SvgFavoritedFilled = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            d: "M12.157 21.958q-.349 0-.713-.125a1.65 1.65 0 0 1-.637-.4l-1.725-1.575a68 68 0 0 1-4.788-4.812q-2.137-2.388-2.137-5.263 0-2.35 1.575-3.925t3.925-1.575q1.325 0 2.5.563t2 1.537a5.96 5.96 0 0 1 2-1.537 5.7 5.7 0 0 1 2.5-.563q2.35 0 3.925 1.575t1.575 3.925q0 2.875-2.125 5.275a60 60 0 0 1-4.825 4.825l-1.7 1.55a1.65 1.65 0 0 1-.638.4q-.362.125-.712.125"
        })
    }));
};
var FavoritedFilled_default = SvgFavoritedFilled;



/***/ }),

/***/ 241538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jd": function() { return /* binding */ ChevronBackButton; },
  "ju": function() { return /* binding */ ChevronDownButton; },
  "bB": function() { return /* binding */ ChevronForwardButton; },
  "x5": function() { return /* binding */ ChevronUpButton; },
  "PZ": function() { return /* binding */ CloseButton; },
  "_6": function() { return /* binding */ FavoriteButton; },
  "Lb": function() { return /* binding */ FilterButton; },
  "hU": function() { return /* binding */ IconButton; },
  "Tz": function() { return /* binding */ ShareButton; }
});

// UNUSED EXPORTS: DownloadButton, EditButton, HideButton, MenuButton, NearMeButton

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(582222);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(320129);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/react-native-svg/dist/esm/index.js
var esm = __webpack_require__(502888);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/Close.js






var SvgClose = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,cjs.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,src_object_spread/* default */.Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Svg */.ny, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Path */.y$, {
            fill: "currentColor",
            d: "m12 13.4-5.776 5.776a1.12 1.12 0 0 1-.825.324q-.501 0-.825-.324a1.12 1.12 0 0 1-.324-.825q0-.502.324-.825l5.776-5.776-5.776-5.776a1.12 1.12 0 0 1-.324-.825q0-.501.324-.825T5.4 4q.502 0 .825.324L12 10.1l5.776-5.776Q18.099 4 18.6 4q.501 0 .825.324t.324.825q0 .502-.324.825L13.65 11.75l5.776 5.776q.324.323.324.825 0 .501-.324.825a1.12 1.12 0 0 1-.825.324q-.502 0-.825-.324z"
        })
    }));
};
var Close_default = SvgClose;


// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/ChevronLeft.js
var ChevronLeft = __webpack_require__(201677);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/ChevronRight.js
var ChevronRight = __webpack_require__(887251);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/ChevronUp.js
var ChevronUp = __webpack_require__(187096);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/ChevronDown.js
var ChevronDown = __webpack_require__(284359);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/Filter.js






var SvgFilter = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,cjs.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,src_object_spread/* default */.Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Svg */.ny, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Path */.y$, {
            fill: "currentColor",
            d: "M17.75 20.25q-1.575 0-2.662-1.087Q14 18.075 14 16.5t1.088-2.662 2.662-1.088 2.663 1.088T21.5 16.5t-1.087 2.663-2.663 1.087m0-2q.725 0 1.238-.512.512-.513.512-1.238t-.512-1.238a1.69 1.69 0 0 0-1.238-.512q-.725 0-1.238.512A1.69 1.69 0 0 0 16 16.5q0 .725.512 1.238.513.512 1.238.512M11 17.5H5a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 16.5q0-.424.287-.713A.97.97 0 0 1 5 15.5h6q.424 0 .713.287.287.288.287.713 0 .424-.287.712A.97.97 0 0 1 11 17.5m-4.75-6.25q-1.575 0-2.662-1.088Q2.5 9.076 2.5 7.5t1.088-2.662Q4.675 3.75 6.25 3.75q1.576 0 2.662 1.088Q10 5.924 10 7.5t-1.088 2.662Q7.826 11.25 6.25 11.25m0-2q.725 0 1.237-.512Q8 8.225 8 7.5t-.513-1.237A1.69 1.69 0 0 0 6.25 5.75q-.725 0-1.237.513A1.69 1.69 0 0 0 4.5 7.5q0 .725.513 1.238.512.512 1.237.512M19 8.5h-6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 12 7.5q0-.424.287-.713A.97.97 0 0 1 13 6.5h6q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 19 8.5"
        })
    }));
};
var Filter_default = SvgFilter;


// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/FavoritedFilled.js
var FavoritedFilled = __webpack_require__(235033);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/FavoriteUnfilled.js






var SvgFavoriteUnfilled = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,cjs.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,src_object_spread/* default */.Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Svg */.ny, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 25,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Path */.y$, {
            fill: "currentColor",
            d: "M12 21.958q-.349 0-.713-.125a1.65 1.65 0 0 1-.637-.4l-1.725-1.575a68 68 0 0 1-4.788-4.812Q2.002 12.658 2 9.783q0-2.35 1.575-3.925T7.5 4.283q1.325 0 2.5.563t2 1.537a5.96 5.96 0 0 1 2-1.537 5.7 5.7 0 0 1 2.5-.563q2.35 0 3.925 1.575T22 9.783q0 2.875-2.125 5.275a60 60 0 0 1-4.825 4.825l-1.7 1.55a1.65 1.65 0 0 1-.637.4q-.363.125-.713.125m-.95-13.575q-.725-1.025-1.55-1.562t-2-.538q-1.5 0-2.5 1t-1 2.5q0 1.3.925 2.763t2.213 2.837a38 38 0 0 0 2.65 2.575q1.362 1.2 2.212 1.975.85-.775 2.213-1.975t2.65-2.575a19 19 0 0 0 2.212-2.837Q20 11.083 20 9.783q0-1.5-1-2.5t-2.5-1q-1.175 0-2 .538-.825.537-1.55 1.562a1.14 1.14 0 0 1-.95.5 1.138 1.138 0 0 1-.95-.5"
        })
    }));
};
var FavoriteUnfilled_default = SvgFavoriteUnfilled;


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/Share.js






var SvgShare = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,cjs.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,src_object_spread/* default */.Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Svg */.ny, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Path */.y$, {
            fill: "currentColor",
            d: "M6.76 20.5q-.727 0-1.243-.517A1.7 1.7 0 0 1 5 18.741V9.065q0-.726.517-1.243a1.7 1.7 0 0 1 1.242-.516h1.76q.374 0 .626.252a.85.85 0 0 1 .253.627q0 .374-.253.627a.85.85 0 0 1-.626.253h-1.76v9.676h10.556V9.065h-1.76a.85.85 0 0 1-.626-.253.85.85 0 0 1-.253-.627q0-.373.253-.627a.85.85 0 0 1 .627-.252h1.759q.726 0 1.242.516.517.517.517 1.243v9.676q0 .725-.517 1.242a1.7 1.7 0 0 1-1.242.517zm4.397-15.987-.791.791a.8.8 0 0 1-.616.253.89.89 0 0 1-.616-.275.93.93 0 0 1-.253-.615.8.8 0 0 1 .253-.616l2.287-2.287a.84.84 0 0 1 .616-.264q.352 0 .616.264L14.94 4.05a.82.82 0 0 1 .242.605q0 .362-.242.626a.86.86 0 0 1-.627.264.86.86 0 0 1-.627-.264l-.77-.77v8.951q0 .374-.252.627a.85.85 0 0 1-.627.253.85.85 0 0 1-.627-.253.85.85 0 0 1-.253-.627z"
        })
    }));
};
var Share_default = SvgShare;


// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/tokens.js
var tokens = __webpack_require__(61274);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/shared/anchorOrButton.js + 1 modules
var anchorOrButton = __webpack_require__(665243);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js











var iconButtonTokens = Components/* tokens.iconButton */.T.iconButton, sharedFrameConfig = {
    name: "IconButton",
    userSelect: "none",
    cursor: "pointer",
    borderStyle: "solid",
    borderWidth: iconButtonTokens.borderWidth.default,
    borderRadius: iconButtonTokens.cornerRadius.default,
    alignItems: "center",
    justifyContent: "center",
    // Mobile safari sometimes adds a default horizontal padding to buttons
    padding: 0,
    animation: "linear",
    animateOnly: cjs.isWeb ? [
        "transform",
        "background-color",
        "border-color",
        "border-top-color",
        "border-left-color",
        "border-bottom-color",
        "border-right-color"
    ] : [
        "transform",
        "backgroundColor",
        "borderColor",
        "borderTopColor",
        "borderLeftColor",
        "borderBottomColor",
        "borderRightColor"
    ],
    focusVisibleStyle: {
        borderColor: iconButtonTokens.color.icon.border.state.focused.default
    },
    pressStyle: {
        scale: (0,tokens/* getStateTokenValue */.GJ)(iconButtonTokens.state.pressedScale)
    },
    variants: {
        variant: function(variant, param) {
            var props = param.props;
            return props.disabled ? {
                backgroundColor: iconButtonTokens.color.icon.background.state.inactive[variant],
                borderColor: iconButtonTokens.color.icon.border.state.inactive[variant]
            } : {
                backgroundColor: iconButtonTokens.color.icon.background[variant],
                borderColor: iconButtonTokens.color.icon.border[variant],
                hoverStyle: {
                    backgroundColor: iconButtonTokens.color.icon.background.state.hover[variant],
                    borderColor: iconButtonTokens.color.icon.border.state.hover[variant]
                }
            };
        },
        frameSize: function(size) {
            return (0,src_object_spread/* default */.Z)({
                width: iconButtonTokens.size[size],
                height: iconButtonTokens.size[size]
            }, size === "small" ? {
                backgroundColor: "$transparent",
                borderColor: "$transparent",
                hoverStyle: {
                    borderColor: "$transparent"
                }
            } : {});
        },
        disabled: {
            true: {
                pointerEvents: "none"
            }
        }
    }
}, AnchorFrame = (0,cjs.styled)(cjs.Text, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, sharedFrameConfig), {
    tag: "a",
    accessibilityRole: "link",
    textDecorationLine: "none",
    display: "flex",
    position: "relative"
})), ButtonFrame = (0,cjs.styled)(cjs.View, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, sharedFrameConfig), {
    tag: "button",
    accessibilityRole: "button"
})), AnchorOrButtonFrame = (0,anchorOrButton/* createAnchorOrButtonFrame */.r)({
    AnchorFrame: AnchorFrame,
    ButtonFrame: ButtonFrame
}), IconButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var size = _param.size, disabled = _param.disabled, icon = _param.icon, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "size",
        "disabled",
        "icon"
    ]);
    var _color, _size;
    var _$ref = (0,cjs.useProps)(rest), _variant = _$ref.variant, variant = _variant === void 0 ? "default" : _variant, iconColor = disabled ? iconButtonTokens.color.icon.content.state.inactive.default : (_color = icon.color) !== null && _color !== void 0 ? _color : iconButtonTokens.color.icon.content[variant], iconSize = (_size = icon.size) !== null && _size !== void 0 ? _size : size === "large" ? 24 : 20;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(AnchorOrButtonFrame, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        disabled: disabled,
        "aria-disabled": disabled,
        focusable: !disabled
    }, rest), {
        variant: variant,
        frameSize: size,
        ref: ref,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(icon.Component, {
            "aria-label": icon.label,
            color: iconColor,
            size: iconSize
        })
    }));
}), CloseButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        icon: {
            Component: Close_default,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "close",
            size: iconSize
        }
    }, props), {
        ref: ref
    }));
}), MenuButton = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = _object_without_properties(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ jsx(IconButton, _object_spread_props(_object_spread({
        icon: {
            Component: Menu,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "menu",
            size: iconSize
        }
    }, props), {
        ref: ref
    }));
}))), ChevronBackButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        icon: {
            Component: ChevronLeft/* default */.Z,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "back",
            size: iconSize
        }
    }, props), {
        ref: ref
    }));
}), ChevronForwardButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        icon: {
            Component: ChevronRight/* default */.Z,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "forward",
            size: iconSize
        }
    }, props), {
        ref: ref
    }));
}), ChevronUpButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        icon: {
            Component: ChevronUp/* default */.Z,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "up",
            size: iconSize
        }
    }, props), {
        ref: ref
    }));
}), ChevronDownButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        icon: {
            Component: ChevronDown/* default */.Z,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "down",
            size: iconSize
        }
    }, props), {
        ref: ref
    }));
}), EditButton = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = _object_without_properties(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ jsx(IconButton, _object_spread_props(_object_spread({
        icon: {
            Component: Edit,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "edit",
            size: iconSize
        }
    }, props), {
        ref: ref
    }));
}))), DownloadButton = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = _object_without_properties(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ jsx(IconButton, _object_spread_props(_object_spread({
        icon: {
            Component: Download,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "download",
            // Medium size uses 24px icon
            size: iconSize !== null && iconSize !== void 0 ? iconSize : props.size === "small" ? 20 : 24
        }
    }, props), {
        ref: ref
    }));
}))), FilterButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        icon: {
            Component: Filter_default,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "filter",
            size: iconSize
        }
    }, props), {
        ref: ref
    }));
}), FavoriteButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, defaultFavorited = _param.defaultFavorited, isFavorited = _param.isFavorited, onPress = _param.onPress, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "iconLabel",
        "iconSize",
        "defaultFavorited",
        "isFavorited",
        "onPress"
    ]);
    var _$ref = (0,react.useState)(defaultFavorited !== null && defaultFavorited !== void 0 ? defaultFavorited : !1), internalIsFavorited = _$ref[0], setInternalIsFavorited = _$ref[1], isControlledComponent = (typeof isFavorited === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(isFavorited)) < "u", favorited = isControlledComponent ? isFavorited : internalIsFavorited, handlePress = (0,react.useCallback)(function(e) {
        return !isControlledComponent && setInternalIsFavorited(function(prev) {
            return !prev;
        }), onPress === null || onPress === void 0 ? void 0 : onPress(e);
    }, [
        isControlledComponent,
        onPress
    ]), icon = (0,react.useMemo)(function() {
        return favorited ? {
            Component: FavoritedFilled/* default */.Z,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "unfavorite",
            size: iconSize,
            color: iconButtonTokens.color.icon.content.favorite
        } : {
            Component: FavoriteUnfilled_default,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "favorite",
            size: iconSize
        };
    }, [
        favorited,
        iconLabel,
        iconSize
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        icon: icon,
        value: favorited ? "false" : "true",
        onPress: handlePress
    }, props), {
        ref: ref
    }));
}), NearMeButton = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = _object_without_properties(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ jsx(IconButton, _object_spread_props(_object_spread({
        icon: {
            Component: NearMe,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "near me",
            size: iconSize
        }
    }, props), {
        ref: ref
    }));
}))), HideButton = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = _object_without_properties(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ jsx(IconButton, _object_spread_props(_object_spread({
        icon: {
            Component: PasswordHide,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "hide",
            size: iconSize
        }
    }, props), {
        ref: ref
    }));
}))), ShareButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var iconLabel = _param.iconLabel, iconSize = _param.iconSize, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "iconLabel",
        "iconSize"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        icon: {
            Component: Share_default,
            label: iconLabel !== null && iconLabel !== void 0 ? iconLabel : "share",
            // Medium size uses 24px icon
            size: iconSize !== null && iconSize !== void 0 ? iconSize : props.size === "small" ? 20 : 24
        }
    }, props), {
        ref: ref
    }));
});



/***/ }),

/***/ 352007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TextButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(999534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(320129);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(201677);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(887251);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61274);
/* harmony import */ var _shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(665243);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(785893);











var textButtonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.textButton */ .T.textButton, buttonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.button */ .T.button, sharedFrameConfig = {
    name: "TextButton",
    display: "flex",
    flexDirection: "row",
    gap: textButtonTokens.padding.labelIconGap.default,
    userSelect: "none",
    cursor: "pointer",
    // Browser resets
    padding: 0,
    borderWidth: 0,
    backgroundColor: "$transparent",
    focusVisibleStyle: {
        outlineStyle: "solid",
        outlineWidth: textButtonTokens.borderWidth.state.default,
        outlineOffset: textButtonTokens.padding.state.focused.default,
        borderRadius: textButtonTokens.cornerRadius.state.focused
    },
    pressStyle: {
        scale: (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_3__/* .getStateTokenValue */ .GJ)(buttonTokens.state.pressedScale)
    },
    variants: {
        variant: function(variant) {
            return {
                focusVisibleStyle: {
                    outlineColor: variant === "secondaryInverse" ? textButtonTokens.color.border.state.inverse : textButtonTokens.color.border.state.default
                }
            };
        },
        disabled: {
            true: {
                pointerEvents: "none"
            }
        }
    }
}, AnchorFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "a",
    accessibilityRole: "link",
    textDecorationLine: "none",
    display: "flex",
    position: "relative"
})), ButtonFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "button",
    accessibilityRole: "button"
})), AnchorOrButtonFrame = (0,_shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__/* .createAnchorOrButtonFrame */ .r)({
    AnchorFrame: AnchorFrame,
    ButtonFrame: ButtonFrame
}), TextButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var variant = _param.variant, disabled = _param.disabled, label = _param.label, onHoverIn = _param.onHoverIn, onHoverOut = _param.onHoverOut, chevronIcon = _param.chevronIcon, fontWeight = _param.fontWeight, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "variant",
        "disabled",
        "label",
        "onHoverIn",
        "onHoverOut",
        "chevronIcon",
        "fontWeight"
    ]);
    var _$ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useProps)(rest), _size = _$ref.size, size = _size === void 0 ? "medium" : _size, _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), isHovering = _$ref1[0], setIsHovering = _$ref1[1], hoverNone = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useMedia)().hoverNone, handleHoverIn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(!0), onHoverIn === null || onHoverIn === void 0 ? void 0 : onHoverIn(e);
    }, [
        hoverNone,
        onHoverIn
    ]), handleHoverOut = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(!1), onHoverOut === null || onHoverOut === void 0 ? void 0 : onHoverOut(e);
    }, [
        hoverNone,
        onHoverOut
    ]), color = disabled ? textButtonTokens.color.content.state.inactive[variant] : isHovering ? textButtonTokens.color.content.state.hover[variant] : textButtonTokens.color.content[variant];
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(AnchorOrButtonFrame, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variant: variant,
        disabled: disabled,
        "aria-disabled": disabled,
        focusable: !disabled,
        onHoverIn: handleHoverIn,
        onHoverOut: handleHoverOut,
        ref: ref
    }, rest), {
        children: [
            chevronIcon === "left" && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                tag: "span",
                typography: textButtonTokens.typography[size],
                textDecorationLine: variant === "primary" || chevronIcon ? "none" : "underline",
                color: color,
                fontWeight: fontWeight ? textButtonTokens.fontWeight[fontWeight] : void 0,
                children: label
            }),
            chevronIcon === "right" && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            })
        ]
    }));
});



/***/ }),

/***/ 333668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _modules_dismissKeyboard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(651763);
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// in the future we can use https://github.com/w3c/virtual-keyboard
var Keyboard = {
  isVisible() {
    return false;
  },
  addListener() {
    return {
      remove: () => {}
    };
  },
  dismiss() {
    (0,_modules_dismissKeyboard__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  },
  removeAllListeners() {},
  removeListener() {}
};
/* harmony default export */ __webpack_exports__["Z"] = (Keyboard);

/***/ }),

/***/ 964645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ exports_PanResponder; }
});

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/InteractionManager/index.js + 2 modules
var InteractionManager = __webpack_require__(469111);
;// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/TouchHistoryMath/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 */

var TouchHistoryMath = {
  /**
   * This code is optimized and not intended to look beautiful. This allows
   * computing of touch centroids that have moved after `touchesChangedAfter`
   * timeStamp. You can compute the current centroid involving all touches
   * moves after `touchesChangedAfter`, or you can compute the previous
   * centroid of all touches that were moved after `touchesChangedAfter`.
   *
   * @param {TouchHistoryMath} touchHistory Standard Responder touch track
   * data.
   * @param {number} touchesChangedAfter timeStamp after which moved touches
   * are considered "actively moving" - not just "active".
   * @param {boolean} isXAxis Consider `x` dimension vs. `y` dimension.
   * @param {boolean} ofCurrent Compute current centroid for actively moving
   * touches vs. previous centroid of now actively moving touches.
   * @return {number} value of centroid in specified dimension.
   */
  centroidDimension: function centroidDimension(touchHistory, touchesChangedAfter, isXAxis, ofCurrent) {
    var touchBank = touchHistory.touchBank;
    var total = 0;
    var count = 0;
    var oneTouchData = touchHistory.numberActiveTouches === 1 ? touchHistory.touchBank[touchHistory.indexOfSingleActiveTouch] : null;
    if (oneTouchData !== null) {
      if (oneTouchData.touchActive && oneTouchData.currentTimeStamp > touchesChangedAfter) {
        total += ofCurrent && isXAxis ? oneTouchData.currentPageX : ofCurrent && !isXAxis ? oneTouchData.currentPageY : !ofCurrent && isXAxis ? oneTouchData.previousPageX : oneTouchData.previousPageY;
        count = 1;
      }
    } else {
      for (var i = 0; i < touchBank.length; i++) {
        var touchTrack = touchBank[i];
        if (touchTrack !== null && touchTrack !== undefined && touchTrack.touchActive && touchTrack.currentTimeStamp >= touchesChangedAfter) {
          var toAdd = void 0; // Yuck, program temporarily in invalid state.
          if (ofCurrent && isXAxis) {
            toAdd = touchTrack.currentPageX;
          } else if (ofCurrent && !isXAxis) {
            toAdd = touchTrack.currentPageY;
          } else if (!ofCurrent && isXAxis) {
            toAdd = touchTrack.previousPageX;
          } else {
            toAdd = touchTrack.previousPageY;
          }
          total += toAdd;
          count++;
        }
      }
    }
    return count > 0 ? total / count : TouchHistoryMath.noCentroid;
  },
  currentCentroidXOfTouchesChangedAfter: function currentCentroidXOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, true,
    // isXAxis
    true // ofCurrent
    );
  },
  currentCentroidYOfTouchesChangedAfter: function currentCentroidYOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, false,
    // isXAxis
    true // ofCurrent
    );
  },
  previousCentroidXOfTouchesChangedAfter: function previousCentroidXOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, true,
    // isXAxis
    false // ofCurrent
    );
  },
  previousCentroidYOfTouchesChangedAfter: function previousCentroidYOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, false,
    // isXAxis
    false // ofCurrent
    );
  },
  currentCentroidX: function currentCentroidX(touchHistory) {
    return TouchHistoryMath.centroidDimension(touchHistory, 0,
    // touchesChangedAfter
    true,
    // isXAxis
    true // ofCurrent
    );
  },
  currentCentroidY: function currentCentroidY(touchHistory) {
    return TouchHistoryMath.centroidDimension(touchHistory, 0,
    // touchesChangedAfter
    false,
    // isXAxis
    true // ofCurrent
    );
  },
  noCentroid: -1
};
/* harmony default export */ var react_native_TouchHistoryMath = (TouchHistoryMath);
;// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/PanResponder/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */





var currentCentroidXOfTouchesChangedAfter = react_native_TouchHistoryMath.currentCentroidXOfTouchesChangedAfter;
var currentCentroidYOfTouchesChangedAfter = react_native_TouchHistoryMath.currentCentroidYOfTouchesChangedAfter;
var previousCentroidXOfTouchesChangedAfter = react_native_TouchHistoryMath.previousCentroidXOfTouchesChangedAfter;
var previousCentroidYOfTouchesChangedAfter = react_native_TouchHistoryMath.previousCentroidYOfTouchesChangedAfter;
var currentCentroidX = react_native_TouchHistoryMath.currentCentroidX;
var currentCentroidY = react_native_TouchHistoryMath.currentCentroidY;

/**
 * `PanResponder` reconciles several touches into a single gesture. It makes
 * single-touch gestures resilient to extra touches, and can be used to
 * recognize simple multi-touch gestures.
 *
 * By default, `PanResponder` holds an `InteractionManager` handle to block
 * long-running JS events from interrupting active gestures.
 *
 * It provides a predictable wrapper of the responder handlers provided by the
 * [gesture responder system](docs/gesture-responder-system.html).
 * For each handler, it provides a new `gestureState` object alongside the
 * native event object:
 *
 * ```
 * onPanResponderMove: (event, gestureState) => {}
 * ```
 *
 * A native event is a synthetic touch event with the following form:
 *
 *  - `nativeEvent`
 *      + `changedTouches` - Array of all touch events that have changed since the last event
 *      + `identifier` - The ID of the touch
 *      + `locationX` - The X position of the touch, relative to the element
 *      + `locationY` - The Y position of the touch, relative to the element
 *      + `pageX` - The X position of the touch, relative to the root element
 *      + `pageY` - The Y position of the touch, relative to the root element
 *      + `target` - The node id of the element receiving the touch event
 *      + `timestamp` - A time identifier for the touch, useful for velocity calculation
 *      + `touches` - Array of all current touches on the screen
 *
 * A `gestureState` object has the following:
 *
 *  - `stateID` - ID of the gestureState- persisted as long as there at least
 *     one touch on screen
 *  - `moveX` - the latest screen coordinates of the recently-moved touch
 *  - `moveY` - the latest screen coordinates of the recently-moved touch
 *  - `x0` - the screen coordinates of the responder grant
 *  - `y0` - the screen coordinates of the responder grant
 *  - `dx` - accumulated distance of the gesture since the touch started
 *  - `dy` - accumulated distance of the gesture since the touch started
 *  - `vx` - current velocity of the gesture
 *  - `vy` - current velocity of the gesture
 *  - `numberActiveTouches` - Number of touches currently on screen
 *
 * ### Basic Usage
 *
 * ```
 *   componentWillMount: function() {
 *     this._panResponder = PanResponder.create({
 *       // Ask to be the responder:
 *       onStartShouldSetPanResponder: (evt, gestureState) => true,
 *       onStartShouldSetPanResponderCapture: (evt, gestureState) => true,
 *       onMoveShouldSetPanResponder: (evt, gestureState) => true,
 *       onMoveShouldSetPanResponderCapture: (evt, gestureState) => true,
 *
 *       onPanResponderGrant: (evt, gestureState) => {
 *         // The gesture has started. Show visual feedback so the user knows
 *         // what is happening!
 *
 *         // gestureState.d{x,y} will be set to zero now
 *       },
 *       onPanResponderMove: (evt, gestureState) => {
 *         // The most recent move distance is gestureState.move{X,Y}
 *
 *         // The accumulated gesture distance since becoming responder is
 *         // gestureState.d{x,y}
 *       },
 *       onPanResponderTerminationRequest: (evt, gestureState) => true,
 *       onPanResponderRelease: (evt, gestureState) => {
 *         // The user has released all touches while this view is the
 *         // responder. This typically means a gesture has succeeded
 *       },
 *       onPanResponderTerminate: (evt, gestureState) => {
 *         // Another component has become the responder, so this gesture
 *         // should be cancelled
 *       },
 *       onShouldBlockNativeResponder: (evt, gestureState) => {
 *         // Returns whether this component should block native components from becoming the JS
 *         // responder. Returns true by default. Is currently only supported on android.
 *         return true;
 *       },
 *     });
 *   },
 *
 *   render: function() {
 *     return (
 *       <View {...this._panResponder.panHandlers} />
 *     );
 *   },
 *
 * ```
 *
 * ### Working Example
 *
 * To see it in action, try the
 * [PanResponder example in RNTester](https://github.com/facebook/react-native/blob/master/RNTester/js/PanResponderExample.js)
 */

var PanResponder = {
  /**
   *
   * A graphical explanation of the touch data flow:
   *
   * +----------------------------+             +--------------------------------+
   * | ResponderTouchHistoryStore |             |TouchHistoryMath                |
   * +----------------------------+             +----------+---------------------+
   * |Global store of touchHistory|             |Allocation-less math util       |
   * |including activeness, start |             |on touch history (centroids     |
   * |position, prev/cur position.|             |and multitouch movement etc)    |
   * |                            |             |                                |
   * +----^-----------------------+             +----^---------------------------+
   *      |                                          |
   *      | (records relevant history                |
   *      |  of touches relevant for                 |
   *      |  implementing higher level               |
   *      |  gestures)                               |
   *      |                                          |
   * +----+-----------------------+             +----|---------------------------+
   * | ResponderEventPlugin       |             |    |   Your App/Component      |
   * +----------------------------+             +----|---------------------------+
   * |Negotiates which view gets  | Low level   |    |             High level    |
   * |onResponderMove events.     | events w/   |  +-+-------+     events w/     |
   * |Also records history into   | touchHistory|  |   Pan   |     multitouch +  |
   * |ResponderTouchHistoryStore. +---------------->Responder+-----> accumulative|
   * +----------------------------+ attached to |  |         |     distance and  |
   *                                 each event |  +---------+     velocity.     |
   *                                            |                                |
   *                                            |                                |
   *                                            +--------------------------------+
   *
   *
   *
   * Gesture that calculates cumulative movement over time in a way that just
   * "does the right thing" for multiple touches. The "right thing" is very
   * nuanced. When moving two touches in opposite directions, the cumulative
   * distance is zero in each dimension. When two touches move in parallel five
   * pixels in the same direction, the cumulative distance is five, not ten. If
   * two touches start, one moves five in a direction, then stops and the other
   * touch moves fives in the same direction, the cumulative distance is ten.
   *
   * This logic requires a kind of processing of time "clusters" of touch events
   * so that two touch moves that essentially occur in parallel but move every
   * other frame respectively, are considered part of the same movement.
   *
   * Explanation of some of the non-obvious fields:
   *
   * - moveX/moveY: If no move event has been observed, then `(moveX, moveY)` is
   *   invalid. If a move event has been observed, `(moveX, moveY)` is the
   *   centroid of the most recently moved "cluster" of active touches.
   *   (Currently all move have the same timeStamp, but later we should add some
   *   threshold for what is considered to be "moving"). If a palm is
   *   accidentally counted as a touch, but a finger is moving greatly, the palm
   *   will move slightly, but we only want to count the single moving touch.
   * - x0/y0: Centroid location (non-cumulative) at the time of becoming
   *   responder.
   * - dx/dy: Cumulative touch distance - not the same thing as sum of each touch
   *   distance. Accounts for touch moves that are clustered together in time,
   *   moving the same direction. Only valid when currently responder (otherwise,
   *   it only represents the drag distance below the threshold).
   * - vx/vy: Velocity.
   */

  _initializeGestureState(gestureState) {
    gestureState.moveX = 0;
    gestureState.moveY = 0;
    gestureState.x0 = 0;
    gestureState.y0 = 0;
    gestureState.dx = 0;
    gestureState.dy = 0;
    gestureState.vx = 0;
    gestureState.vy = 0;
    gestureState.numberActiveTouches = 0;
    // All `gestureState` accounts for timeStamps up until:
    gestureState._accountsForMovesUpTo = 0;
  },
  /**
   * This is nuanced and is necessary. It is incorrect to continuously take all
   * active *and* recently moved touches, find the centroid, and track how that
   * result changes over time. Instead, we must take all recently moved
   * touches, and calculate how the centroid has changed just for those
   * recently moved touches, and append that change to an accumulator. This is
   * to (at least) handle the case where the user is moving three fingers, and
   * then one of the fingers stops but the other two continue.
   *
   * This is very different than taking all of the recently moved touches and
   * storing their centroid as `dx/dy`. For correctness, we must *accumulate
   * changes* in the centroid of recently moved touches.
   *
   * There is also some nuance with how we handle multiple moved touches in a
   * single event. With the way `ReactNativeEventEmitter` dispatches touches as
   * individual events, multiple touches generate two 'move' events, each of
   * them triggering `onResponderMove`. But with the way `PanResponder` works,
   * all of the gesture inference is performed on the first dispatch, since it
   * looks at all of the touches (even the ones for which there hasn't been a
   * native dispatch yet). Therefore, `PanResponder` does not call
   * `onResponderMove` passed the first dispatch. This diverges from the
   * typical responder callback pattern (without using `PanResponder`), but
   * avoids more dispatches than necessary.
   */
  _updateGestureStateOnMove(gestureState, touchHistory) {
    gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
    gestureState.moveX = currentCentroidXOfTouchesChangedAfter(touchHistory, gestureState._accountsForMovesUpTo);
    gestureState.moveY = currentCentroidYOfTouchesChangedAfter(touchHistory, gestureState._accountsForMovesUpTo);
    var movedAfter = gestureState._accountsForMovesUpTo;
    var prevX = previousCentroidXOfTouchesChangedAfter(touchHistory, movedAfter);
    var x = currentCentroidXOfTouchesChangedAfter(touchHistory, movedAfter);
    var prevY = previousCentroidYOfTouchesChangedAfter(touchHistory, movedAfter);
    var y = currentCentroidYOfTouchesChangedAfter(touchHistory, movedAfter);
    var nextDX = gestureState.dx + (x - prevX);
    var nextDY = gestureState.dy + (y - prevY);

    // TODO: This must be filtered intelligently.
    var dt = touchHistory.mostRecentTimeStamp - gestureState._accountsForMovesUpTo;
    gestureState.vx = (nextDX - gestureState.dx) / dt;
    gestureState.vy = (nextDY - gestureState.dy) / dt;
    gestureState.dx = nextDX;
    gestureState.dy = nextDY;
    gestureState._accountsForMovesUpTo = touchHistory.mostRecentTimeStamp;
  },
  /**
   * @param {object} config Enhanced versions of all of the responder callbacks
   * that provide not only the typical `ResponderSyntheticEvent`, but also the
   * `PanResponder` gesture state.  Simply replace the word `Responder` with
   * `PanResponder` in each of the typical `onResponder*` callbacks. For
   * example, the `config` object would look like:
   *
   *  - `onMoveShouldSetPanResponder: (e, gestureState) => {...}`
   *  - `onMoveShouldSetPanResponderCapture: (e, gestureState) => {...}`
   *  - `onStartShouldSetPanResponder: (e, gestureState) => {...}`
   *  - `onStartShouldSetPanResponderCapture: (e, gestureState) => {...}`
   *  - `onPanResponderReject: (e, gestureState) => {...}`
   *  - `onPanResponderGrant: (e, gestureState) => {...}`
   *  - `onPanResponderStart: (e, gestureState) => {...}`
   *  - `onPanResponderEnd: (e, gestureState) => {...}`
   *  - `onPanResponderRelease: (e, gestureState) => {...}`
   *  - `onPanResponderMove: (e, gestureState) => {...}`
   *  - `onPanResponderTerminate: (e, gestureState) => {...}`
   *  - `onPanResponderTerminationRequest: (e, gestureState) => {...}`
   *  - `onShouldBlockNativeResponder: (e, gestureState) => {...}`
   *
   *  In general, for events that have capture equivalents, we update the
   *  gestureState once in the capture phase and can use it in the bubble phase
   *  as well.
   *
   *  Be careful with onStartShould* callbacks. They only reflect updated
   *  `gestureState` for start/end events that bubble/capture to the Node.
   *  Once the node is the responder, you can rely on every start/end event
   *  being processed by the gesture and `gestureState` being updated
   *  accordingly. (numberActiveTouches) may not be totally accurate unless you
   *  are the responder.
   */
  create(config) {
    var interactionState = {
      handle: null,
      shouldCancelClick: false,
      timeout: null
    };
    var gestureState = {
      // Useful for debugging
      stateID: Math.random(),
      moveX: 0,
      moveY: 0,
      x0: 0,
      y0: 0,
      dx: 0,
      dy: 0,
      vx: 0,
      vy: 0,
      numberActiveTouches: 0,
      _accountsForMovesUpTo: 0
    };
    var panHandlers = {
      onStartShouldSetResponder(event) {
        return config.onStartShouldSetPanResponder == null ? false : config.onStartShouldSetPanResponder(event, gestureState);
      },
      onMoveShouldSetResponder(event) {
        return config.onMoveShouldSetPanResponder == null ? false : config.onMoveShouldSetPanResponder(event, gestureState);
      },
      onStartShouldSetResponderCapture(event) {
        // TODO: Actually, we should reinitialize the state any time
        // touches.length increases from 0 active to > 0 active.
        if (event.nativeEvent.touches.length === 1) {
          PanResponder._initializeGestureState(gestureState);
        }
        gestureState.numberActiveTouches = event.touchHistory.numberActiveTouches;
        return config.onStartShouldSetPanResponderCapture != null ? config.onStartShouldSetPanResponderCapture(event, gestureState) : false;
      },
      onMoveShouldSetResponderCapture(event) {
        var touchHistory = event.touchHistory;
        // Responder system incorrectly dispatches should* to current responder
        // Filter out any touch moves past the first one - we would have
        // already processed multi-touch geometry during the first event.
        if (gestureState._accountsForMovesUpTo === touchHistory.mostRecentTimeStamp) {
          return false;
        }
        PanResponder._updateGestureStateOnMove(gestureState, touchHistory);
        return config.onMoveShouldSetPanResponderCapture ? config.onMoveShouldSetPanResponderCapture(event, gestureState) : false;
      },
      onResponderGrant(event) {
        if (!interactionState.handle) {
          interactionState.handle = InteractionManager/* default.createInteractionHandle */.Z.createInteractionHandle();
        }
        if (interactionState.timeout) {
          clearInteractionTimeout(interactionState);
        }
        interactionState.shouldCancelClick = true;
        gestureState.x0 = currentCentroidX(event.touchHistory);
        gestureState.y0 = currentCentroidY(event.touchHistory);
        gestureState.dx = 0;
        gestureState.dy = 0;
        if (config.onPanResponderGrant) {
          config.onPanResponderGrant(event, gestureState);
        }
        // TODO: t7467124 investigate if this can be removed
        return config.onShouldBlockNativeResponder == null ? true : config.onShouldBlockNativeResponder(event, gestureState);
      },
      onResponderReject(event) {
        clearInteractionHandle(interactionState, config.onPanResponderReject, event, gestureState);
      },
      onResponderRelease(event) {
        clearInteractionHandle(interactionState, config.onPanResponderRelease, event, gestureState);
        setInteractionTimeout(interactionState);
        PanResponder._initializeGestureState(gestureState);
      },
      onResponderStart(event) {
        var touchHistory = event.touchHistory;
        gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
        if (config.onPanResponderStart) {
          config.onPanResponderStart(event, gestureState);
        }
      },
      onResponderMove(event) {
        var touchHistory = event.touchHistory;
        // Guard against the dispatch of two touch moves when there are two
        // simultaneously changed touches.
        if (gestureState._accountsForMovesUpTo === touchHistory.mostRecentTimeStamp) {
          return;
        }
        // Filter out any touch moves past the first one - we would have
        // already processed multi-touch geometry during the first event.
        PanResponder._updateGestureStateOnMove(gestureState, touchHistory);
        if (config.onPanResponderMove) {
          config.onPanResponderMove(event, gestureState);
        }
      },
      onResponderEnd(event) {
        var touchHistory = event.touchHistory;
        gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
        clearInteractionHandle(interactionState, config.onPanResponderEnd, event, gestureState);
      },
      onResponderTerminate(event) {
        clearInteractionHandle(interactionState, config.onPanResponderTerminate, event, gestureState);
        setInteractionTimeout(interactionState);
        PanResponder._initializeGestureState(gestureState);
      },
      onResponderTerminationRequest(event) {
        return config.onPanResponderTerminationRequest == null ? true : config.onPanResponderTerminationRequest(event, gestureState);
      },
      // We do not want to trigger 'click' activated gestures or native behaviors
      // on any pan target that is under a mouse cursor when it is released.
      // Browsers will natively cancel 'click' events on a target if a non-mouse
      // active pointer moves.
      onClickCapture: event => {
        if (interactionState.shouldCancelClick === true) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    };
    return {
      panHandlers,
      getInteractionHandle() {
        return interactionState.handle;
      }
    };
  }
};
function clearInteractionHandle(interactionState, callback, event, gestureState) {
  if (interactionState.handle) {
    InteractionManager/* default.clearInteractionHandle */.Z.clearInteractionHandle(interactionState.handle);
    interactionState.handle = null;
  }
  if (callback) {
    callback(event, gestureState);
  }
}
function clearInteractionTimeout(interactionState) {
  clearTimeout(interactionState.timeout);
}
function setInteractionTimeout(interactionState) {
  interactionState.timeout = setTimeout(() => {
    interactionState.shouldCancelClick = false;
  }, 250);
}
/* harmony default export */ var react_native_PanResponder = (PanResponder);
;// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/PanResponder/index.js

/* harmony default export */ var exports_PanResponder = (react_native_PanResponder);

/***/ }),

/***/ 469438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XA": function() { return /* reexport */ Dismissable; }
});

// UNUSED EXPORTS: DismissableBranch, dispatchDiscreteCustomEvent

// EXTERNAL MODULE: ./node_modules/@tamagui/compose-refs/dist/esm/compose-refs.mjs
var compose_refs = __webpack_require__(594030);
// EXTERNAL MODULE: ./node_modules/@tamagui/helpers/dist/esm/index.mjs + 5 modules
var esm = __webpack_require__(247533);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
;// CONCATENATED MODULE: ./node_modules/@tamagui/use-callback-ref/dist/esm/index.mjs

function useCallbackRef(callback) {
  const callbackRef = react.useRef(callback);
  return react.useEffect(() => {
    callbackRef.current = callback;
  }), react.useMemo(() => (...args) => callbackRef.current?.(...args), []);
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/use-escape-keydown/dist/esm/index.mjs


function useEscapeKeydown(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
  const onEscapeKeyDown = useCallbackRef(onEscapeKeyDownProp);
  react.useEffect(() => {
    const handleKeyDown = event => {
      event.key === "Escape" && onEscapeKeyDown(event);
    };
    return ownerDocument.addEventListener("keydown", handleKeyDown), () => {
      ownerDocument.removeEventListener("keydown", handleKeyDown);
    };
  }, [onEscapeKeyDown, ownerDocument]);
}

//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/use-event/dist/esm/index.mjs + 2 modules
var dist_esm = __webpack_require__(113989);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(973935);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/dismissable/dist/esm/Dismissable.mjs







function dispatchDiscreteCustomEvent(target, event) {
  target && react_dom.flushSync(() => target.dispatchEvent(event));
}
const DISMISSABLE_LAYER_NAME = "Dismissable",
  CONTEXT_UPDATE = "dismissable.update",
  POINTER_DOWN_OUTSIDE = "dismissable.pointerDownOutside",
  FOCUS_OUTSIDE = "dismissable.focusOutside";
let originalBodyPointerEvents;
const DismissableContext = react.createContext({
    layers: /* @__PURE__ */new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */new Set(),
    branches: /* @__PURE__ */new Set()
  }),
  Dismissable = react.forwardRef((props, forwardedRef) => {
    const {
        disableOutsidePointerEvents = !1,
        forceUnmount,
        onEscapeKeyDown,
        onPointerDownOutside,
        onFocusOutside,
        onInteractOutside,
        onDismiss,
        ...layerProps
      } = props,
      context = react.useContext(DismissableContext),
      [node, setNode] = react.useState(null),
      [, force] = react.useState({}),
      composedRefs = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, node2 => setNode(node2)),
      layers = Array.from(context.layers),
      [highestLayerWithOutsidePointerEventsDisabled] = [...context.layersWithOutsidePointerEventsDisabled].slice(-1),
      highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled),
      index = node ? layers.indexOf(node) : -1,
      isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0,
      isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex,
      pointerDownOutside = usePointerDownOutside(event => {
        const target = event.target,
          isPointerDownOnBranch = [...context.branches].some(branch => branch.contains(target));
        !isPointerEventsEnabled || isPointerDownOnBranch || (onPointerDownOutside?.(event), onInteractOutside?.(event), event.defaultPrevented || onDismiss?.());
      }),
      focusOutside = useFocusOutside(event => {
        const target = event.target;
        [...context.branches].some(branch => branch.contains(target)) || (onFocusOutside?.(event), onInteractOutside?.(event), event.defaultPrevented || onDismiss?.());
      });
    return useEscapeKeydown(event => {
      index === context.layers.size - 1 && (onEscapeKeyDown?.(event), !event.defaultPrevented && onDismiss && (event.preventDefault(), onDismiss()));
    }), react.useEffect(() => {
      if (node) return disableOutsidePointerEvents && (context.layersWithOutsidePointerEventsDisabled.size === 0 && (originalBodyPointerEvents = document.body.style.pointerEvents, document.body.style.pointerEvents = "none"), context.layersWithOutsidePointerEventsDisabled.add(node)), context.layers.add(node), dispatchUpdate(), () => {
        disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1 && (document.body.style.pointerEvents = originalBodyPointerEvents);
      };
    }, [node, disableOutsidePointerEvents, context]), react.useEffect(() => {
      if (!forceUnmount) return () => {
        node && (context.layers.delete(node), context.layersWithOutsidePointerEventsDisabled.delete(node), dispatchUpdate());
      };
    }, [node, context, forceUnmount]), react.useEffect(() => {
      const handleUpdate = () => {
        force({});
      };
      return document.addEventListener(CONTEXT_UPDATE, handleUpdate), () => document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
    }, []), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ...layerProps,
      ref: composedRefs,
      style: {
        display: "contents",
        pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
        // @ts-ignore
        ...props.style
      },
      onFocusCapture: (0,esm/* composeEventHandlers */.Mj)(props.onFocusCapture, focusOutside.onFocusCapture),
      onBlurCapture: (0,esm/* composeEventHandlers */.Mj)(props.onBlurCapture, focusOutside.onBlurCapture),
      onPointerDownCapture: (0,esm/* composeEventHandlers */.Mj)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
  });
Dismissable.displayName = DISMISSABLE_LAYER_NAME;
const BRANCH_NAME = "DismissableBranch",
  DismissableBranch = react.forwardRef((props, forwardedRef) => {
    const context = react.useContext(DismissableContext),
      ref = react.useRef(null),
      composedRefs = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, ref);
    return react.useEffect(() => {
      const node = ref.current;
      if (node) return context.branches.add(node), () => {
        context.branches.delete(node);
      };
    }, [context.branches]), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      style: {
        display: "contents"
      },
      ...props,
      ref: composedRefs
    });
  });
DismissableBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(onPointerDownOutside) {
  const handlePointerDownOutside = (0,dist_esm/* useEvent */.z)(onPointerDownOutside),
    isPointerInsideReactTreeRef = react.useRef(!1),
    handleClickRef = react.useRef(() => {});
  return react.useEffect(() => {
    const handlePointerDown = event => {
        if (event.target && !isPointerInsideReactTreeRef.current) {
          let handleAndDispatchPointerDownOutsideEvent = function () {
            handleAndDispatchCustomEvent(POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
              discrete: !0
            });
          };
          const eventDetail = {
            originalEvent: event
          };
          event.pointerType === "touch" ? (document.removeEventListener("click", handleClickRef.current), handleClickRef.current = handleAndDispatchPointerDownOutsideEvent, document.addEventListener("click", handleClickRef.current, {
            once: !0
          })) : handleAndDispatchPointerDownOutsideEvent();
        }
        isPointerInsideReactTreeRef.current = !1;
      },
      timerId = setTimeout(() => {
        document.addEventListener("pointerdown", handlePointerDown);
      }, 0);
    return () => {
      window.clearTimeout(timerId), document.removeEventListener("pointerdown", handlePointerDown), document.removeEventListener("click", handleClickRef.current);
    };
  }, [handlePointerDownOutside]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => {
      isPointerInsideReactTreeRef.current = !0;
    }
  };
}
function useFocusOutside(onFocusOutside) {
  const handleFocusOutside = (0,dist_esm/* useEvent */.z)(onFocusOutside),
    isFocusInsideReactTreeRef = react.useRef(!1);
  return react.useEffect(() => {
    const handleFocus = event => {
      event.target && !isFocusInsideReactTreeRef.current && handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, {
        originalEvent: event
      }, {
        discrete: !1
      });
    };
    return document.addEventListener("focusin", handleFocus), () => document.removeEventListener("focusin", handleFocus);
  }, [handleFocusOutside]), {
    onFocusCapture: () => {
      isFocusInsideReactTreeRef.current = !0;
    },
    onBlurCapture: () => {
      isFocusInsideReactTreeRef.current = !1;
    }
  };
}
function dispatchUpdate() {
  const event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name, handler, detail, {
  discrete
}) {
  const target = detail.originalEvent.target,
    event = new CustomEvent(name, {
      bubbles: !1,
      cancelable: !0,
      detail
    });
  handler && target.addEventListener(name, handler, {
    once: !0
  }), discrete ? dispatchDiscreteCustomEvent(target, event) : target.dispatchEvent(event);
}

//# sourceMappingURL=Dismissable.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/dismissable/dist/esm/index.mjs

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 990099:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ ThemeableStack; }
});

// UNUSED EXPORTS: themeableVariants

// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/stacks/dist/esm/Stacks.mjs
var Stacks = __webpack_require__(743702);
// EXTERNAL MODULE: ./node_modules/@tamagui/stacks/dist/esm/getElevation.mjs
var getElevation = __webpack_require__(752702);
;// CONCATENATED MODULE: ./node_modules/@tamagui/stacks/dist/esm/variants.mjs

const elevate = {
    true: (_, extras) => (0,getElevation/* getElevation */.y)(extras.props.size, extras)
  },
  bordered = (val, {
    props
  }) => ({
    // TODO size it with size in '...size'
    borderWidth: typeof val == "number" ? val : 1,
    borderColor: "$borderColor",
    ...(props.hoverTheme && {
      hoverStyle: {
        borderColor: "$borderColorHover"
      }
    }),
    ...(props.pressTheme && {
      pressStyle: {
        borderColor: "$borderColorPress"
      }
    }),
    ...(props.focusTheme && {
      focusStyle: {
        borderColor: "$borderColorFocus"
      }
    })
  }),
  padded = {
    true: (_, extras) => {
      const {
        tokens,
        props
      } = extras;
      return {
        padding: tokens.space[props.size] || tokens.space.$true
      };
    }
  },
  radiused = {
    true: (_, extras) => {
      const {
        tokens,
        props
      } = extras;
      return {
        borderRadius: tokens.radius[props.size] || tokens.radius.$true
      };
    }
  },
  circularStyle = {
    borderRadius: 1e5,
    padding: 0
  },
  circular = {
    true: (_, {
      props,
      tokens
    }) => {
      if (!("size" in props)) return circularStyle;
      const size = typeof props.size == "number" ? props.size : tokens.size[props.size];
      return {
        ...circularStyle,
        width: size,
        height: size,
        maxWidth: size,
        maxHeight: size,
        minWidth: size,
        minHeight: size
      };
    }
  },
  hoverTheme = {
    true: {
      hoverStyle: {
        backgroundColor: "$backgroundHover",
        borderColor: "$borderColorHover"
      }
    },
    false: {}
  },
  pressTheme = {
    true: {
      cursor: "pointer",
      pressStyle: {
        backgroundColor: "$backgroundPress",
        borderColor: "$borderColorPress"
      }
    },
    false: {}
  },
  focusTheme = {
    true: {
      focusStyle: {
        backgroundColor: "$backgroundFocus",
        borderColor: "$borderColorFocus"
      }
    },
    false: {}
  };

//# sourceMappingURL=variants.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/stacks/dist/esm/ThemeableStack.mjs



const chromelessStyle = {
    backgroundColor: "transparent",
    borderColor: "transparent",
    shadowColor: "transparent",
    hoverStyle: {
      borderColor: "transparent"
    }
  },
  themeableVariants = {
    backgrounded: {
      true: {
        backgroundColor: "$background"
      }
    },
    radiused: radiused,
    hoverTheme: hoverTheme,
    pressTheme: pressTheme,
    focusTheme: focusTheme,
    circular: circular,
    padded: padded,
    elevate: elevate,
    bordered: bordered,
    transparent: {
      true: {
        backgroundColor: "transparent"
      }
    },
    chromeless: {
      true: chromelessStyle,
      all: {
        ...chromelessStyle,
        hoverStyle: chromelessStyle,
        pressStyle: chromelessStyle,
        focusStyle: chromelessStyle
      }
    }
  },
  ThemeableStack = (0,cjs.styled)(Stacks/* YStack */.FA, {
    variants: themeableVariants
  });

//# sourceMappingURL=ThemeableStack.mjs.map


/***/ }),

/***/ 481430:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useControllableState; }
/* harmony export */ });
/* harmony import */ var _tamagui_use_event__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(113989);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _tamagui_start_transition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(128031);



const emptyCallbackFn = _ => _();
function useControllableState({
  prop,
  defaultProp,
  onChange,
  strategy = "prop-wins",
  preventUpdate,
  transition
}) {
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_1__.useState(prop ?? defaultProp),
    previous = react__WEBPACK_IMPORTED_MODULE_1__.useRef(state),
    propWins = strategy === "prop-wins" && prop !== void 0,
    value = propWins ? prop : state,
    onChangeCb = (0,_tamagui_use_event__WEBPACK_IMPORTED_MODULE_0__/* .useEvent */ .z)(onChange || idFn),
    transitionFn = transition ? _tamagui_start_transition__WEBPACK_IMPORTED_MODULE_2__/* .startTransition */ .L : emptyCallbackFn;
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    prop !== void 0 && (previous.current = prop, transitionFn(() => {
      setState(prop);
    }));
  }, [prop]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    propWins || state !== previous.current && (previous.current = state, onChangeCb(state));
  }, [onChangeCb, state, propWins]);
  const setter = (0,_tamagui_use_event__WEBPACK_IMPORTED_MODULE_0__/* .useEvent */ .z)(next => {
    if (!preventUpdate) if (propWins) {
      const nextValue = typeof next == "function" ? next(previous.current) : next;
      onChangeCb(nextValue);
    } else transitionFn(() => {
      setState(next);
    });
  });
  return [value, setter];
}
const idFn = () => {};

//# sourceMappingURL=useControllableState.mjs.map


/***/ }),

/***/ 113989:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useEvent; }
});

// UNUSED EXPORTS: useGet

// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var esm = __webpack_require__(275425);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
;// CONCATENATED MODULE: ./node_modules/@tamagui/use-event/dist/esm/useGet.mjs


function useGet(currentValue, initialValue, forwardToFunction) {
  const curRef = react.useRef(initialValue ?? currentValue);
  return (0,esm/* useIsomorphicLayoutEffect */.LI)(() => {
    curRef.current = currentValue;
  }), react.useCallback(forwardToFunction ? (...args) => curRef.current?.apply(null, args) : () => curRef.current, []);
}

//# sourceMappingURL=useGet.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/use-event/dist/esm/useEvent.mjs

function useEvent(callback) {
  return useGet(callback, defaultValue, !0);
}
const defaultValue = () => {
  throw new Error("Cannot call an event handler while rendering.");
};

//# sourceMappingURL=useEvent.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/use-event/dist/esm/index.mjs


//# sourceMappingURL=index.mjs.map


/***/ })

}]);